export default __webpack_public_path__ + "static/media/maple.ab95c40f.mp4";